export default (browserLocale: string): string => {
  if (!browserLocale) {
    return browserLocale;
  }
  switch (browserLocale.split('-')[0]) {
    case 'cs':
      return 'cs-CZ';
    case 'da':
      return 'da-DK';
    case 'de':
    case 'de-AT':
    case 'de-CH':
      return 'de-DE';
    case 'es':
      return 'es-ES';
    case 'et':
      return 'et-EE';
    case 'fi':
      return 'fi-FI';
    case 'fr':
    case 'fr-BE':
    case 'fr-CH':
      return 'fr-FR';
    case 'hu':
      return 'hu-HU';
    case 'it':
    case 'it-CH':
      return 'it-IT';
    case 'lt':
      return 'lt-LT';
    case 'nl':
      return 'nl-NL';
    case 'no':
    case 'nb':
    case 'nn':
    case 'no-NB':
    case 'no-NN':
      return 'no-NO';
    case 'pl':
      return 'pl-PL';
    case 'pt':
      return 'pt-BR';
    case 'sl':
      return 'sl-SI';
    case 'sv':
      return 'sv-SE';
    case 'ja':
      return 'ja-JP';

    default:
      return 'en-US';
  }
};
